module.exports = __webpack_public_path__ + "img/education.983c0632.svg";